import { render, staticRenderFns } from "./ChurchCanvas.vue?vue&type=template&id=21bd9558&"
import script from "./ChurchCanvas.vue?vue&type=script&lang=js&"
export * from "./ChurchCanvas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports